const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/petso/dashboard/calendar.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/petso/dashboard/calendar')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});